module.exports = __webpack_public_path__ + "img/pemmican-cookhouse.7ae9e074.webp";